// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './ed... Remove this comment to see the full error message
import { editorConfig } from './editorConfig';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import { start } from 'ContentEditorUI/UniversalApplication';
start(editorConfig);